import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '~/lib/constants'
import {
  requestNextApiEndpoint,
  SHOPIFY_ADMIN_ORDER_PARAMS,
} from '~/lib/handle-api'

import { useCustomerContext } from '@unlikelystudio/react-ecommerce-hooks'

import useLocale from '~/hooks/useLocale'

export default function useGetAdminOrder(orderId) {
  const locale = useLocale()
  const { customerAccessToken } = useCustomerContext()

  return useQuery(
    [QUERY_KEYS.ORDER_ADMIN, orderId],
    async () => {
      const response = await requestNextApiEndpoint(
        SHOPIFY_ADMIN_ORDER_PARAMS,
        {
          accessToken: customerAccessToken,
          queryParams: { id: orderId, locale },
        },
      )
      const { transactions } = response?.data?.order ?? {}

      const paymentDetails = transactions?.find((t) => t?.formattedGateway)

      return {
        paymentDetails,
      }
    },
    { enabled: Boolean(orderId), keepPreviousData: true, staleTime: 10000 },
  )
}
